$(document).ready(function(){

  var myCookie = readCookie('pop-covid');

  if(myCookie){
    $(".bottom-band").css("display","block");
  }

  if(!myCookie){
    setTimeout(function(){
      $(".pop-up-kenworth").fadeToggle("slow");
      createCookie("pop-covid",true,1);
    }, 3000);
  }

  $(document).keyup(function(e) {
    if (e.keyCode === 27){
      $(".pop-up-kenworth").fadeOut("slow");
      $(".bottom-band").fadeIn("slow");
    }
  });

  $(".pop-up-kenworth .close-btn").on("click",function(){
    $(".pop-up-kenworth").fadeToggle("slow");
    $(".bottom-band").fadeToggle("slow");
  });

  $(".bottom-band").on("click",function(){
    $(this).fadeToggle();
    $(".pop-up-kenworth").fadeToggle("slow");
  });


  function createCookie(name,value,days) {
    if (days) {
      var date = new Date();
      date.setTime(date.getTime()+(days*24*60*60*1000));
      var expires = "; expires="+date.toGMTString();
    }
    else var expires = "";
    document.cookie = name+"="+value+expires+"; path=/";
  }

  function readCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
  }

  function eraseCookie(name) {
    createCookie(name,"",-1);
  }

  window.Parsley.setLocale($('html').attr('lang'));

  if ($('form.parsley').length > 0){
    $('form.parsley').parsley({});
  }

  $("input[name='date']").datepicker({
      language: 'fr',
      minDate: new Date(), // Now can select only dates, which goes after today
      position: 'top left'
  });

  /*
  ===============
  ==Mobile Menu==
  ===============
  */
  $(".burger-menu").click(function(){
    $(this).toggleClass("active");
    $(".bottom-menu").toggleClass("active");
    $("body").toggleClass("active");
  });
  $(".has-sub-menu").on("click",function(){
    $(this).toggleClass("active");
    $(this).find(".sub-menu").toggleClass("active");
  });

  /*
  ===============
  ===FANCY BOX===
  ===============
  */
  $("[data-fancybox]").fancybox({
    loop: true,
  });

  /*
  ==========================
  ==Smooth Scroll function==
  ==========================
  */
  $(function() {
    $('a[href*="#"]:not([href="#"])').click(function() {
      if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 1000);
          return false;
        }
      }
    });
  });

  /*
  ====================
  ==Open a modal box==
  ====================
  */
  var myModal = "";
  $(".modal-trigger").click(function(){
    myModal = $(this).attr("href");
    $(myModal).fadeIn("slow");
    $(".modal-overlay").fadeIn("slow");
  });
  $(".modal-footer .btn").click(function(){
    $(myModal).fadeOut("slow");
    $(".modal-overlay").fadeOut("slow");
  });

  /*
  =================================================
  ==Gros cheat pour formulaire rdv car "kenworth"==
  =================================================
  */
  $('input[name="motif"]').on('change', function(e){
    var that = $(this),
    selecter = $('select[name="secteur"]');

    if(that.val().indexOf('SAAQ') >= 0) {
    if (selecter.val() == 4) {
        selecter.val(0);
      }

      selecter.find('option[value="4"]').attr('disabled', 'disabled');
    }
    else{
    selecter.find('option[value="4"]').removeAttr('disabled');
    }
  });

  /*
  =================================================
  ======================GOALS======================
  =================================================
  */

  $(".phone-goals").on("click",function(){
    console.log("test");
    ga('send', {
      hitType: 'event',
      eventCategory: 'siteweb',
      eventAction: 'click',
      eventLabel: 'click-telephone',
      eventValue: 1
    });
    gtag_report_conversion();
  });

  if($(".goal-contact-success").length){
    ga('send', {
      hitType: 'event',
      eventCategory: 'siteweb',
      eventAction: 'sent',
      eventLabel: 'sent-contact-form',
      eventValue: 1
    });
  }

  if($(".goals-rdv-succes").length){
    ga('send', {
      hitType: 'event',
      eventCategory: 'siteweb',
      eventAction: 'sent',
      eventLabel: 'sent-rdv-form',
      eventValue: 1
    });
  }

  if($(".goals-demandeInfo-success").length){
    gtag('event', 'conversion', {'send_to': 'AW-831024366/bXc3CJH5wIABEO7ZoYwD'});
    ga('send', {
      hitType: 'event',
      eventCategory: 'siteweb',
      eventAction: 'sent',
      eventLabel: 'sent-demande-info',
      eventValue: 1
    });
  }

  //CONFIDENTIALITÉ
	var cookieAccepted = readCookie("cookieAccepted");
  if(!cookieAccepted){
    $(".pop-up-confidentialite").addClass("popped");
  }

  $(".btn-politique").on("click",function(){
    createCookie("cookieAccepted", true, 365);
    location.reload();
  });

  $(window).on('scroll', function() {
    var y_scroll_pos = window.pageYOffset;
    var headerheight = $("header").outerHeight();
    if(y_scroll_pos > headerheight) {
      $(".promo-sticker").addClass("stick-top");
    }
    else{
      $(".promo-sticker").removeClass("stick-top");
    }
  });

  var stickerOff = readCookie("stickerOff");
  if(!stickerOff){
    $(".promo-sticker").css("display","block");
  }
  $(".promo-sticker .close-btn").on("click",function(e){
    createCookie("stickerOff", true, 1);
    $(".promo-sticker").fadeOut();
    e.preventDefault();
  });

});

/*
==========================================
==Recalling bg-cover to prevent glitches==
==========================================
*/
$(window).resize(function(){
  $(".bg-cover").backgroundCover();
});

$(window).on('load',function() {
  $(".bg-cover").backgroundCover();
});

$(document).ready(function(){

  $(".bg-cover").backgroundCover();

  window.onfocus = function () {
    $(".bg-cover").backgroundCover();
  };

  window.onblur = function () {
    $(".bg-cover").backgroundCover();
  };

});
